import { render, staticRenderFns } from "./HarnessSelectionStats.vue?vue&type=template&id=23e0b8c5"
import script from "./HarnessSelectionStats.vue?vue&type=script&lang=js"
export * from "./HarnessSelectionStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports